// extracted by mini-css-extract-plugin
export default {"loading":"PageApp_loading__G7mEg","fadein":"PageApp_fadein__dgd+a","spinner":"PageApp_spinner__dTAdv","message":"PageApp_message__ooO-W"};